const defaultState = {
    ajaxLoading: false,
    ajaxLoaded: false,
    default_configurations: [],
    configuration_types: {},
    page: 1,
    limit: 30,
    showEditModal: false,
    showRemoveModal: false,
    activeRow: {},
};

const default_configurations = (state = defaultState, action) => {
    switch (action.type) {
        case 'DEFAULT_CONFIGURATIONS_SET_PAGE':
            return Object.assign({}, state, { page: action.payload });
        case 'DEFAULT_CONFIGURATIONS_SET_LIMIT':
            return Object.assign({}, state, { limit: action.payload });
        case 'DEFAULT_CONFIGURATIONS_SHOW_EDIT_MODAL':
            return Object.assign({}, state, { showEditModal: action.payload });
        case 'DEFAULT_CONFIGURATIONS_SHOW_REMOVE_MODAL':
            return Object.assign({}, state, { showRemoveModal: action.payload });
        case 'DEFAULT_CONFIGURATIONS_SET_ACTIVE_ROW':
            return Object.assign({}, state, { activeRow: action.payload });
        case 'DEFAULT_CONFIGURATIONS_SET_ROW_VALUE':
            const activeRow = Object.assign({}, state.activeRow, action.payload);
            return Object.assign({}, state, { activeRow });
        case 'DEFAULT_CONFIGURATIONS_FETCHING':
        case 'DEFAULT_CONFIGURATIONS_SAVING':
        case 'DEFAULT_CONFIGURATIONS_REMOVING':
            return Object.assign({}, state, { ajaxLoading: true });
        case 'DEFAULT_CONFIGURATIONS_FETCHED':
            return Object.assign({}, state, { ajaxLoading: false, ajaxLoaded: true, ...action.payload });
        case 'DEFAULT_CONFIGURATIONS_SAVED':
            return Object.assign({}, state, { ajaxLoading: false, showEditModal: false });
        case 'DEFAULT_CONFIGURATIONS_REMOVED':
            return Object.assign({}, state, { ajaxLoading: false, showRemoveModal: false });
        default:
            return state;
    }
};

export default default_configurations;
